import { type ReactNode } from 'react';
import { Outlet } from 'react-router';

import Stack from '@mui/material/Stack';

import loginLayoutWebp from '@assets/images/login-layout.webp';
type PublicRoutesLayoutPT = {
  children?: ReactNode;
};
export const PublicRoutesLayout = ({ children }: PublicRoutesLayoutPT) => {
  return (
    <Stack
      sx={{
        height: '100vh',
        width: '100vw',
        background: `url(${loginLayoutWebp})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {children ? children : <Outlet />}
    </Stack>
  );
};
